module.exports = __webpack_public_path__ + "img/bg.a7c068b1.png";